<template>
  <div class="coupon-card" :class="{ 'member-only': item.memberOnly, picked: item.picked }">
    <!-- 会员专属标签 -->
    <div class="member-badge" v-show="item.memberOnly">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1L10.5 5.5L15.5 6.5L12 10L13 15L8 12.5L3 15L4 10L0.5 6.5L5.5 5.5L8 1Z" fill="#FFD700" />
      </svg>
      <span>会员专属</span>
    </div>

    <!-- 已领取状态 -->
    <div class="status-badge" v-show="item.picked">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" fill="#FE7448" fill-opacity="0.1" stroke="#FE7448" stroke-width="1.5" />
        <path d="M7 10L9 12L13 8" stroke="#FE7448" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>已领取</span>
    </div>

    <!-- 优惠券主体 -->
    <div class="coupon-body">
      <div class="coupon-content">
        <div class="coupon-value">
          <span class="value-text">{{ item.valueContent }}</span>
        </div>
        <div class="coupon-details">
          <div class="coupon-name-container">
            <el-tooltip class="item" effect="dark" :content="item.description" placement="top-start">
              <span class="coupon-name">{{ item.name }}</span>
            </el-tooltip>
          </div>
          <p class="coupon-description">{{ item.title }}</p>
          <div class="validity-period">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="6.5" stroke="#999" stroke-opacity="0.7" />
              <path d="M7 3.5V7L9.5 9.5" stroke="#999" stroke-opacity="0.7" stroke-linecap="round" />
            </svg>
            <span>有效期：{{ item.useContent }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="coupon-footer">
      <button class="action-btn use-btn" v-if="item.picked" @click="handleUseCoupon">
        <span>立即使用</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3 8H13M13 8L10 5M13 8L10 11"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
      <button class="action-btn get-btn" v-else @click="pickCustomerCouponFn(item)">
        <span>立即领取</span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- 装饰元素 -->
    <div class="decoration-left"></div>
    <div class="decoration-right"></div>
  </div>
</template>

<script>
import { pickCustomerCoupon } from "@/api/coupon/index.js";

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    // 领取优惠券
    async pickCustomerCouponFn(data) {
      try {
        await pickCustomerCoupon(data.id);
        this.$emit("hadPick");
        // 可以在这里添加领取成功提示
        this.$message.success("优惠券领取成功！");
      } catch (error) {
        console.error("领取优惠券失败:", error);
        this.$message.error(error.message || "领取失败，请稍后重试");
      }
    },

    // 使用优惠券
    handleUseCoupon() {
      this.$store.commit("search/setSearchData", {
        couponId: this.item.customerCouponId,
        type: -1
      });
      this.$router.push({ path: "/new-products/product-list" });
      // this.$emit("useCoupon", this.item);
      // 可以在这里添加跳转逻辑或使用优惠券的逻辑
      // this.$message.info("即将跳转到使用页面...");
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon-card {
  width: 100%;
  max-width: 320px;
  min-height: 160px;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  // 会员专属样式
  &.member-only {
    border: 1px solid rgba(254, 116, 72, 0.2);

    .coupon-body::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #fe7448, #ff9d6c);
    }
  }

  // 已领取样式
  &.picked {
    opacity: 0.9;

    .coupon-value .value-text {
      opacity: 0.8;
    }
  }
}

// 会员专属标签
.member-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  background: rgba(254, 116, 72, 0.1);
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  color: #fe7448;
  z-index: 2;

  svg {
    margin-right: 4px;
  }
}

// 已领取状态
.status-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 600;
  color: #fe7448;
  z-index: 2;

  svg {
    margin-right: 4px;
  }
}

// 优惠券主体
.coupon-body {
  flex: 1;
  padding: 20px 16px 16px;
  position: relative;

  .coupon-content {
    display: flex;
    align-items: flex-start;
  }

  .coupon-value {
    margin-right: 12px;
    flex-shrink: 0;

    .value-text {
      font-size: 28px;
      font-weight: 700;
      color: #fe7448;
      line-height: 1;
    }
  }

  .coupon-details {
    flex: 1;

    .coupon-name-container {
      margin-bottom: 6px;

      .coupon-name {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        line-height: 1.3;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    .coupon-description {
      font-size: 12px;
      color: #666;
      line-height: 1.4;
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .validity-period {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #999;

      svg {
        margin-right: 4px;
      }
    }
  }
}

// 底部按钮区域
.coupon-footer {
  padding: 0 16px 16px;

  .action-btn {
    width: 100%;
    height: 36px;
    border: none;
    border-radius: 18px;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;

    svg {
      margin-left: 6px;
      transition: transform 0.3s ease;
    }

    &:hover svg {
      transform: translateX(3px);
    }
  }

  .get-btn {
    background: linear-gradient(135deg, #fe7448, #ff9d6c);
    color: white;
    box-shadow: 0 2px 8px rgba(254, 116, 72, 0.3);

    &:hover {
      box-shadow: 0 4px 12px rgba(254, 116, 72, 0.4);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .use-btn {
    background: rgba(254, 116, 72, 0.1);
    color: #fe7448;
    border: 1px solid rgba(254, 116, 72, 0.3);

    &:hover {
      background: rgba(254, 116, 72, 0.15);
      box-shadow: 0 2px 8px rgba(254, 116, 72, 0.2);
    }
  }
}

// 装饰元素
.decoration-left,
.decoration-right {
  position: absolute;
  width: 20px;
  height: 20px;
  background: #f8f9fa;
  border-radius: 50%;
  bottom: 60px;
}

.decoration-left {
  left: -10px;
}

.decoration-right {
  right: -10px;
}

// 响应式调整
@media (max-width: 480px) {
  .coupon-card {
    max-width: 100%;
  }

  .coupon-body {
    padding: 16px 12px 12px;

    .coupon-value .value-text {
      font-size: 24px;
    }

    .coupon-details .coupon-name {
      font-size: 14px;
    }
  }

  .coupon-footer {
    padding: 0 12px 12px;
  }
}
</style>
